export default "__VITE_ASSET__BRlVVB8I__"